module.exports = __webpack_public_path__ + "static/media/innerLogo.5ab37d44.png";